"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getVariantNumberOfRounds = void 0;
const getOrderLinesNumberOfRounds_1 = require("./getOrderLinesNumberOfRounds");
const getVariantNumberOfRounds = (variant) => {
    if (!variant)
        return 0;
    if (!variant.order_lines)
        return 0;
    return (0, getOrderLinesNumberOfRounds_1.getOrderLinesNumberOfRounds)(variant.order_lines);
};
exports.getVariantNumberOfRounds = getVariantNumberOfRounds;
